import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import ExploreIcon from '@mui/icons-material/Explore';
import { useNavigate } from '@tanstack/react-router';
import { useDemoTour } from '@/features/demo/tour/useDemoTour';

export default function DemoBanner() {
  const navigate = useNavigate();
  const { startTour } = useDemoTour();

  return (
    <Box
      sx={{
        backgroundColor: '#FFF3E0',
        borderBottom: '1px solid #FFE0B2',
        px: 2,
        py: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 2,
        flexWrap: 'wrap',
      }}
    >
      <Typography variant="body2" sx={{ color: '#E65100', fontWeight: 500 }}>
        You&apos;re exploring a demo &mdash; data resets in 24 hours.
      </Typography>
      <Button
        variant="outlined"
        size="small"
        startIcon={<ExploreIcon />}
        onClick={startTour}
        sx={{
          textTransform: 'none',
          fontWeight: 600,
          borderColor: '#E65100',
          color: '#E65100',
          '&:hover': { borderColor: '#BF360C', backgroundColor: 'rgba(230, 81, 0, 0.04)' },
        }}
      >
        Take a Tour
      </Button>
      <Button
        variant="contained"
        size="small"
        onClick={() => navigate({ to: '/register' })}
        sx={{
          backgroundColor: '#0466C8',
          textTransform: 'none',
          fontWeight: 600,
          '&:hover': { backgroundColor: '#0353A4' },
        }}
      >
        Sign Up
      </Button>
    </Box>
  );
}
